import { SortingTypes } from "@/helpers/SortingTypes";

export interface PartnersFilter {
  status?: string;
  responsible?: string;
  created_at_from?: string;
  created_at_to?: string;
  search?: string;
  limit?: number;
  offset?: number;
  sort_column?: string;
  sort_direction?: SortingTypes;
}

export const defaultPartnersFilterFields: PartnersFilter = {
  status: undefined,
  responsible: undefined,
  created_at_from: undefined,
  created_at_to: undefined,
  search: undefined,
  limit: undefined,
  offset: undefined,
  sort_column: undefined,
  sort_direction: undefined,
};

